import Swal from 'sweetalert2';

export default new class ButtonBlock {
  constructor() {
    this.sBlockWrapper = 'buy-offer';
    this.preLoaderSelector = 'buy-button__preloader';
  }

  update(offerID, alert = false) {
    this.offerID = offerID;
    $.request('Buy::onBuy', {
      context: this,
      data: { offerID },
      success(response) {
        $(`*[block-id="${this.sBlockWrapper}-${offerID}"`).html(response.update).promise().done(() => {
          if (alert) {
            const el = document.createElement('div');
            el.innerHTML = response.buttons;
            this.element = el;
            this.name = response.name;
            this.dialog();
          }
        });
      },
    });
  }

  dialog() {
    Swal.fire({
      title: `${this.name}!`,
      text: 'додано у кошик!',
      icon: 'success',
      showConfirmButton: false,
      html: this.element,
      customClass: {
        popup: 'swal-dialog',
      },
    });
  }
}();
